export interface WSLogEntry {
  id: string;
  timestamp: Date;
  type: 'connecting' | 'connected' | 'opened' | 'closed' | 'error' | 'message' | 'ping' | 'pong';
  data?: any;
  icon: string;
  color: string;
}

type LogListener = (logs: WSLogEntry[]) => void;

class WSLogStore {
  private logs: WSLogEntry[] = [];
  private listeners: Set<LogListener> = new Set();
  private maxLogs = 100; // Keep last 100 entries

  addLog(type: WSLogEntry['type'], data?: any) {
    const iconMap = {
      connecting: '🔄',
      connected: '✅',
      opened: '🔓',
      closed: '❌',
      error: '⚠️',
      message: '📨',
      ping: '🏓',
      pong: '🏓',
    };

    const colorMap = {
      connecting: '#3b82f6',
      connected: '#10b981',
      opened: '#8b5cf6',
      closed: '#ef4444',
      error: '#f59e0b',
      message: '#06b6d4',
      ping: '#84cc16',
      pong: '#84cc16',
    };

    const entry: WSLogEntry = {
      id: `${Date.now()}-${Math.random()}`,
      timestamp: new Date(),
      type,
      data,
      icon: iconMap[type],
      color: colorMap[type],
    };

    this.logs.push(entry);

    // Keep only last N entries
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(-this.maxLogs);
    }

    this.notifyListeners();
  }

  subscribe(listener: LogListener) {
    this.listeners.add(listener);
    // Immediately send current logs
    listener([...this.logs]);

    return () => {
      this.listeners.delete(listener);
    };
  }

  clear() {
    this.logs = [];
    this.notifyListeners();
  }

  private notifyListeners() {
    const logsCopy = [...this.logs];
    this.listeners.forEach((listener) => listener(logsCopy));
  }
}

export const wsLogStore = new WSLogStore();
